import http from './http'

// 获取列表
export function pageList (data) {
  return http.get('/client/fb/token/pagelist?'+data)
}

// 批量生成激活码
export function create (data) {
  return http.post('/client/fb/token', data)
}

export function remove (id) {
  return http.delete('/client/fb/token?id=' + id)
}

export function resetToken (id) {
  return http.put('/client/fb/token/set_config?token=' + id)
}
